import React from 'react';

import ReportTemplate from 'src/components/ReportTemplate';

const Report = (props: Record<string, unknown>) => {
  return <ReportTemplate {...props} />;
};

export default Report;
